var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.875 10.625L5.17418 6.32582C5.90641 5.59359 7.09359 5.59359 7.82583 6.32583L12.125 10.625M10.875 9.375L12.0492 8.20082C12.7814 7.46859 13.9686 7.46859 14.7008 8.20083L17.125 10.625M2.125 13.75H15.875C16.5654 13.75 17.125 13.1904 17.125 12.5V2.5C17.125 1.80964 16.5654 1.25 15.875 1.25H2.125C1.43464 1.25 0.875 1.80964 0.875 2.5V12.5C0.875 13.1904 1.43464 13.75 2.125 13.75ZM10.875 4.375H10.8813V4.38125H10.875V4.375ZM11.1875 4.375C11.1875 4.54759 11.0476 4.6875 10.875 4.6875C10.7024 4.6875 10.5625 4.54759 10.5625 4.375C10.5625 4.20241 10.7024 4.0625 10.875 4.0625C11.0476 4.0625 11.1875 4.20241 11.1875 4.375Z",
    stroke: "#5E5E5E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/image-icon.1ba3a22bc889be672f4683b86c87dcf4.svg";
export { ForwardRef as ReactComponent };